import { useForm } from "react-hook-form";
import * as yup from "yup";
import { phoneRegExp } from "../../utils";

export type HolderFormType = {
  id?: string;
  email: string;
  name: string;
  phoneNumber: string;
  cityId: string;
};

const validationSchema = yup.object<HolderFormType>().shape({
  id: yup.string(),
  email: yup
    .string()
    .email("Email non corretta")
    .required("Campo obbligatorio"),
  name: yup.string().required("Campo obbligatorio"),
  cityId: yup.string().required("Campo obbligatorio"),
  phoneNumber: yup
    .string()
    .matches(phoneRegExp, "Il numero inserito non è valido")
    .required("Campo obbligatorio"),
});

const useHolderForm = (defaultValues?: HolderFormType) => {
  const form = useForm<HolderFormType>({ validationSchema, defaultValues });

  return form;
};

export default useHolderForm;
